import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Authenticated } from "./components/helper";
import "./components/assets/css/style.css";
import "./components/assets/css/responsive.css";
import reportWebVitals from "./reportWebVitals";
import "./components/assets/css/font-awesome.min.css";

import Login from "./components/login";
import Dashboard from "./components/dashboard";
import Products from "./components/products";
import Orders from "./components/orders";
import KitchenOrders from "./components/orders/kitchenOrders";
import Vendors from "./components/vendors";
import Account from "./components/account";
import Settings from "./components/settings";
import Freeproducts from "./components/freeproducts";
import AddFreeproducts from "./components/freeproducts/addfreeproducts";
import EditFreeproducts from "./components/freeproducts/editfreeproducts";
import Holiday from "./components/holiday/";
import HolidayAdd from "./components/holiday/holidayadd";
import HolidayEdit from "./components/holiday/holidayedit";
import ForgotPassword from "./components/account/Forgotpassword";
import Sociallinks from "./components/settings/social-links";
import Stripepaymentkey from "./components/settings/stripe-paymentkey";
import Changepassword from "./components/settings/changepassword";
/*import Accountdetail from './components/account/accountdetail';*/
import SiteSettings from "./components/settings/site-settings";
import Allergens from "./components/allergens";
import AllergensAdd from "./components/allergens/addallergens";
import AllergensEdit from "./components/allergens/editallergens";
import Ingredients from "./components/ingredients";
import IngredientsAdd from "./components/ingredients/addingredient";
import IngredientsEdit from "./components/ingredients/editingredient";
import Freeproductspdf from "./components/freeproductspdf";
import AddFreeproductspdf from "./components/freeproductspdf/addfreeproductspdf";
import EditFreeproductspdf from "./components/freeproductspdf/editfreeproductspdf";
import ResetPassword from "./components/account/ResetPassword";
import Stripepaymentlog from "./components/settings/stripe-paymentlog";
import MasterEntry from "./components/master-entry";
import MasterEntryAdd from "./components/master-entry/addmaster";
import MasterEntryEdit from "./components/master-entry/editmaster";
import PdfViewer from "./components/products/pdfViewer";
import AddRoles from "./components/role/addRoles";
import Roles from "./components/role";
import EditRoles from "./components/role/editRoles";
import AddUser from "./components/account/addUser";
import Unauthorized from "./components/common/Unauthorized";
import NotificationSettings from "./components/settings/notification-setting";
import SessionSettings from "./components/settings/session-setting";
import FreeOrders from "./components/freeorders";
import Freecode from "./components/freecode";
import AddFreecode from "./components/freecode/freecodeadd";
import EditFreecode from "./components/freecode/freecodeedit";
import Promotions from "./components/promotions";
import AddPromotions from "./components/promotions/addpromotions";
import EditPromotions from "./components/promotions/editpromotions";
import PromoOffers from "./components/promooffers";
import AddPromoOffers from "./components/promooffers/addpromooffers";
import EditPromoOffers from "./components/promooffers/editpromooffers";
import AddSectorPromoOffers from "./components/promooffers/sector/addsectorpromooffers";
import EditSectorPromoOffers from "./components/promooffers/sector/editsectorpromooffers";
import Depot from "./components/depots";
import AddDepot from "./components/depots/adddepot";
import EditDepot from "./components/depots/editdepot";
import Chefs from "./components/chef";
import AddChefs from "./components/chef/addchef";
import EditChefs from "./components/chef/editchef";
import Accountcode from "./components/restrictedaccounts";
import AddAccountcode from "./components/restrictedaccounts/accountcodeadd";
import AccountcodeEdit from "./components/restrictedaccounts/accountcodeedit";
import MasterAccountcode from "./components/master-login";
import MasterAccountcodeAdd from "./components/master-login/masterAccountAdd";
import MasterAccountcodeEdit from "./components/master-login/masterAccountEdit";
import EmailConfigs from "./components/email";
import AddEmailConfig from "./components/email/addEmailConfig";
import EditEmailConfig from "./components/email/editEmailConfig";
import EmailLogs from "./components/email/emailLogs";
import UnsubscribedList from "./components/email/unsubscribedList";
import AddEmailCampaign from "./components/email/addEmailCampaign";
import EmailCampaign from "./components/email/emailCampaign";
import EditEmailCampaign from "./components/email/editEmailCampaign";
import AutoEmailSettings from "./components/email/emailsettings";
import Faq from "./components/vendorhub/faq";
import AddFaq from "./components/vendorhub/faq/addfaq";
import EditFaq from "./components/vendorhub/faq/editfaq";
import CustomerLeadForms from "./components/vendorhub/customerLeadForms";
import VendorAuthEmail from "./components/vendorhub/customerLeadForms/vendorauthemail";
import HoAccountcode from "./components/horestrictedacounts";
import HoAccountcodeAdd from "./components/horestrictedacounts/hoaccountcodeadd";
import HoAccountcodeEdit from "./components/horestrictedacounts/hoaccountcodeedit";
import HoAccount from "./components/hoaccount";
import HoAccountAdd from "./components/hoaccount/hoadd";
import HoAccountEdit from "./components/hoaccount/hoedit";
import ChefAccountcode from "./components/chefrestrictedaccounts";
import ChefAccountcodeAdd from "./components/chefrestrictedaccounts/chefaccountcodeadd";
import ChefAccountcodeEdit from "./components/chefrestrictedaccounts/chefaccountcodeedit";
import CMSEditor from "./components/vendorhub/CMS/CMSEditor";
import HeroSectionEditor from "./components/vendorhub/CMS/sections/HeroSectionEditor";
import KitchenAccount from "./components/kitchenaccount"
import KitchenAccountAdd from "./components/kitchenaccount/kitchenAccountadd"
import KitchenAccountEdit from "./components/kitchenaccount/kitchenAccountedit"
import PromoPinsaEmail from "./components/promooffers/promopinsa/promopinsaFeedBackForm";
import PromoPinsaSettings from "./components/promooffers/promopinsa/promopinsaEmailSetting";
import "./i18n";
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route
          exact
          path="/resetpassword/:token/:userid"
          element={<ResetPassword />}
        />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="/" element={<Authenticated />}>
          <Route path="products" element={<Products />} />

          <Route path="orders" element={<Orders />} />
          <Route path="kitchen-orders" element={<KitchenOrders />} />
          <Route path="vendors" element={<Vendors />} />
          <Route path="account" element={<Account />} />
          <Route path="settings" element={<Settings />} />
          <Route path="freeproducts" element={<Freeproducts />} />
          <Route
            path="freeproducts/addfreeproducts"
            element={<AddFreeproducts />}
          />
          <Route
            path="freeproducts/editfreeproducts/:id"
            element={<EditFreeproducts />}
          />
          <Route path="holiday" element={<Holiday />} />
          <Route path="holiday/add" element={<HolidayAdd />} />
          <Route path="holiday/edit/:id" element={<HolidayEdit />} />

          <Route path="changepassword" element={<Changepassword />} />
          <Route path="social-links" element={<Sociallinks />} />
          <Route path="stripe-paymentkey" element={<Stripepaymentkey />} />
          <Route path="stripe-paymentlog" element={<Stripepaymentlog />} />
          <Route path="site-settings" element={<SiteSettings />} />
          <Route path="email-configuration" element={<EmailConfigs />} />
          <Route path="email-configuration/add" element={<AddEmailConfig />} />
          <Route
            path="email-configuration/edit"
            element={<EditEmailConfig />}
          />
          <Route path="email-logs" element={<EmailLogs />} />
          <Route path="unsubscribed" element={<UnsubscribedList />} />
          {/* <Route path="loggedinnotordered-emailcampaign" element={<LoggedinNotOrderedCampaign />} /> */}
          <Route path="email-campaign/add" element={<AddEmailCampaign />} />
          <Route path="email-campaign" element={<EmailCampaign />} />
          <Route path="email-campaign/edit" element={<EditEmailCampaign />} />
          <Route path="email-settings" element={<AutoEmailSettings /> } />
          <Route exact path="master-entry/:name" element={<MasterEntry />} />
          <Route path="master-entry/add/:name" element={<MasterEntryAdd />} />
          <Route
            path="master-entry/edit/:name/:id/"
            element={<MasterEntryEdit />}
          />
          <Route path="allergens" element={<Allergens />} />
          <Route path="allergens/add" element={<AllergensAdd />} />
          <Route path="allergens/edit/:id/" element={<AllergensEdit />} />
          <Route path="ingredients" element={<Ingredients />} />
          <Route path="ingredients/add" element={<IngredientsAdd />} />
          <Route path="ingredients/edit/:id/" element={<IngredientsEdit />} />
          <Route path="newproducts" element={<Freeproductspdf />} />
          <Route path="newproducts/add" element={<AddFreeproductspdf />} />
          <Route
            path="newproducts/edit/:id/"
            element={<EditFreeproductspdf />}
          />

          <Route path="PdfViewer" element={<PdfViewer />} />
          <Route path="role" element={<Roles />} />
          <Route path="role/addRoles" element={<AddRoles />} />
          <Route path="role/editRoles/:id/" element={<EditRoles />} />
          <Route path="account/adduser" element={<AddUser />} />
          <Route path="notification" element={<NotificationSettings />} />
          <Route path="clearsession" element={<SessionSettings />} />
          <Route path="unauthorized" element={<Unauthorized />} />
          <Route path="freesample/freeorders" element={<FreeOrders />} />
          <Route path="freesample/freecode" element={<Freecode />} />
          <Route path="freesample/freecode/add" element={<AddFreecode />} />
          <Route
            path="freesample/freecode/edit/:id/"
            element={<EditFreecode />}
          />
          <Route path="promotions/" element={<Promotions />} />
          <Route path="promotions/add" element={<AddPromotions />} />
          <Route path="promotions/edit/:id/" element={<EditPromotions />} />
          <Route path="promooffers/" element={<PromoOffers />} />
          <Route path="promooffers/add" element={<AddPromoOffers />} />
          <Route path="promooffers/edit/:id/" element={<EditPromoOffers />} />
          <Route path="promooffers/sector/add" element={<AddSectorPromoOffers />} />
          <Route path="promooffers/sector/edit/:id/" element={<EditSectorPromoOffers />} />
          <Route path="depot/" element={<Depot />} />
          <Route path="depot/add" element={<AddDepot />} />
          <Route path="depot/edit/:id/" element={<EditDepot />} />
          <Route path="development-chef/" element={<Chefs />} />
          <Route path="development-chef/add" element={<AddChefs />} />
          <Route path="development-chef/edit/:id/" element={<EditChefs />} />
          <Route
            path="restrictedaccountcode/accountcode"
            element={<Accountcode />}
          />
          <Route
            path="restrictedaccountcode/accountcode/add"
            element={<AddAccountcode />}
          />
          <Route
            path="restrictedaccountcode/accountcode/edit/:id/"
            element={<AccountcodeEdit />}
          />
          <Route
            path="/headoffice/accountcode"
            element={<HoAccountcode />}
          />
          <Route
            path="/headoffice/accountcode/add"
            element={<HoAccountcodeAdd />}
          />
          <Route
          path="/headoffice/accountcode/edit/:id"
          element={<HoAccountcodeEdit />}
          />
          <Route
            path="/headoffice/account"
            element={<HoAccount />}
          />
          <Route
            path="/headoffice/account/add"
            element={<HoAccountAdd />}
          />
          <Route
            path="/headoffice/account/edit/:id"
            element={<HoAccountEdit />}
          />
          <Route
            path="masteraccountcode/accountcode"
            element={<MasterAccountcode />}
          />
          <Route
            path="masteraccountcode/accountcode/add"
            element={<MasterAccountcodeAdd />}
          />
          <Route
            path="masteraccountcode/accountcode/edit/:id/"
            element={<MasterAccountcodeEdit />}
          />
          <Route
            path="/chef/accountcode"
            element={<ChefAccountcode />}
          />
          <Route
            path="/chef/accountcode/add"
            element={<ChefAccountcodeAdd />}
          />
          <Route
            path="/chef/accountcode/edit/:id"
            element={<ChefAccountcodeEdit />}
          />
          <Route path="vendorhub/faq" element={<Faq />} />
          <Route path="vendorhub/faq/add/" element={<AddFaq />} />
          <Route path="vendorhub/faq/edit/:id/" element={<EditFaq />} />
          <Route path="vendorhub/food-service-partner-lead-forms" element={<CustomerLeadForms />} />
          <Route path="vendorhub/food-service-partner" element={<CMSEditor />} />
          <Route path="vendorhub/food-service-partner-auth-email" element={<VendorAuthEmail /> } />
          <Route path="vendorhub/hero-section-editor" element={<HeroSectionEditor />} />
          
          <Route path="/kitchenaccount" element={<KitchenAccount />} />
          <Route path="/kitchenaccount/add" element={<KitchenAccountAdd />} />
          <Route path="/kitchenaccount/edit/:id" element={<KitchenAccountEdit />} />
          <Route path="/promooffers/feedback-form" element={<PromoPinsaEmail />} />
          <Route path="/promo-pinsa-settings" element={<PromoPinsaSettings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
